import { Column } from '@components/LinearLayout';
import {
  SectionRoot,
  Subtitle,
  SubtitleWrapper,
  Title,
  TitleWrapper,
} from './styles';

interface TextSectionProps {
  title: string;
  paragraphs?: string[];
}

const TextSection = ({ title, paragraphs }: TextSectionProps) => {
  return (
    <section>
      <SectionRoot>
        <Column $gap="2rem" $alignItems="center">
          <TitleWrapper>
            <Title>{title}</Title>
          </TitleWrapper>

          <SubtitleWrapper >
            {paragraphs?.map((paragraph: string) => {
              return (
                <Subtitle key={`text-section-${paragraphs?.length ?? ''}`}>{paragraph}</Subtitle>
              );
            })}
          </SubtitleWrapper>
        </Column>
      </SectionRoot>
    </section>
  );
};

export default TextSection;
